module.exports = __webpack_public_path__ + "static/media/pana1.01e8fda9.png";